<template>
  <el-dialog
    :title="title"
    :visible.sync="showDialog"
    :before-close="cancelAction"
    width="1025px"
    append-to-body
  >
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <span class="m-r-6">商品名称</span>
        <el-input
          v-model="params.item_name"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">货号</span>
        <el-input
          v-model="params.item_bn"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
        <el-button
          type="text"
          @click="refreshGoods"
        >
          同步商品
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="listData"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      @select="handleSelectionChange"
      @select-all="selectAll"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="50"
      />
      <el-table-column
        prop="item_bn"
        width="200px"
        label="商品货号"
      />
      <el-table-column
        prop="item_name"
        label="商品名称"
      />
      <el-table-column
        prop="sku"
        label="规格"
      />
    </el-table>

    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page="params.page"
          :total="total_count"
          :page-size="params.page_size"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <span class="m-r-6">已选中{{ selectCount }}个商品</span>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="saveAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getGoodsList } from '@/api/component'
export default {
  name: 'SpGoodsSelect',
  props: {
    goodsVisible: {
      // 展示模态框
      type: Boolean,
      default: false
    },
    selectData: {
      // 已勾选的列表数据
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: '选择商品'
    },
    chooseOne: {
      // 只可选择一个
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      key: 1,
      listData: [],
      total_count: 0,
      loading: false,
      params: {
        page: 1,
        page_size: 10,
        item_name: '',
        item_bn: ''
      },
      multipleSelection: [],
      submitLoading: false,
      selectCount: 0,
      firstShow: false
    }
  },
  computed: {
    showDialog () {
      return this.goodsVisible
    }
  },
  watch: {
    goodsVisible (newVal, oldVal) {
      if (newVal) {
        this.firstShow = true
        this.selectCount = this.selectData ? this.selectData.length : 0
        this.getList('getFirst')
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.item_id
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getList()
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('closeGoodsDialog')

      // 如果不需要默认勾选则关闭取消
      if (!this.selectData) {
        this.multipleSelection = []
        this.selectCount = 0
        this.$refs.multipleTable.clearSelection()
      }
    },
    async getList (type) {
      this.loading = true
      const data = await getGoodsList(this.params)
      if (data) {
        if (data.total_count < 1 && type === 'getFirst') {
          this.refreshGoods('first')
        }
        this.listData = data.list
        this.total_count = data.total_count
        this.loading = false

        // 可传数组对象，也可传数组id
        if (this.firstShow) {
          this.firstShow = false
          this.toggleSelection(this.selectData)
        }
      }
    },
    searchList () {
      this.params.page = 1
      this.getList()
    },
    // 全选事件
    selectAll (val) {
      this.multipleSelection = val
      this.selectCount = val.length
    },
    // table表格选择
    handleSelectionChange (selection, row) {
      if (this.chooseOne) {
        // 单选
        this.$refs.multipleTable.clearSelection()
        if (selection.length === 0) {
          return
        } else {
          this.multipleSelection = [row]
          this.selectCount = 1
          this.$refs.multipleTable.toggleRowSelection(row, true)
        }
      } else {
        this.multipleSelection = selection
        this.selectCount = selection.length
      }
    },
    saveAction () {
      // 保存选中的Ids
      let goodsIds = []
      this.multipleSelection.forEach((v) => {
        goodsIds = goodsIds.concat(v.item_id)
      })
      this.$emit('chooseGoods', this.multipleSelection, goodsIds.join(','))
    },
    toggleSelection (rows) {
      if (rows && rows.length > 0) {
        rows.forEach((row) => {
          if (row.item_id) {
            this.$refs.multipleTable.toggleRowSelection(row, true)
          } else {
            let newrow = { item_id: row }
            this.$refs.multipleTable.toggleRowSelection(newrow, true)
          }
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },

    // 同步更新商品
    async refreshGoods (type) {
      const data = await this.$api.component.refreshGoods()
      if (data && type !== 'first') {
        this.$message({
          message: '更新同步成功',
          type: 'success'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
